/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius, gridSize } from '@atlaskit/theme';

import { overflowEllipsis } from 'src/styles/mixins';

export const Item = styled.a({
  display: 'flex',
  alignItems: 'center',
  maxWidth: `${gridSize() * 39}px`,
  textDecoration: 'none',
  color: 'inherit',
  '&:hover, &:visited, &:focus, &:active': {
    textDecoration: 'none',
    color: 'inherit',
  },
  '> div:first-child': {
    '> span, > img': {
      borderRadius: `${borderRadius()}px`,
    },
  },
});

export const ProjectInfo = styled.div({
  overflow: 'hidden',
  paddingLeft: `${gridSize()}px`,
});

export const ProjectName = styled.div(overflowEllipsis());

export const SiteName = styled.small(
  {
    display: 'block',
    marginTop: `${gridSize() / 2}px`,
  },
  overflowEllipsis()
);
